import * as React from 'react'
import { Label } from '@/components/ui/label'
import { cn } from '@/lib/utils'

interface FormGroupProps {
  label?: string
  error?: string
  required?: boolean
  tooltip?: string
  className?: string
  children: React.ReactNode
  htmlFor?: string
}

export const FormGroup: React.FC<FormGroupProps> = ({
  label,
  error,
  required,
  tooltip,
  className,
  children,
  htmlFor,
}) => {
  return (
    <div className={cn('space-y-2', className)}>
      {label && (
        <div className="flex items-center gap-2">
          <Label htmlFor={htmlFor} className={error ? 'text-destructive' : ''}>
            {label}
            {required && <span className="text-destructive ml-1">*</span>}
          </Label>
          {tooltip && (
            <span className="text-xs text-muted-foreground" title={tooltip}>
              ⓘ
            </span>
          )}
        </div>
      )}
      {children}
      {error && <p className="text-sm text-destructive">{error}</p>}
    </div>
  )
}
